"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var services_1 = require("stremio/services");
var components_1 = require("stremio/components");
var components_2 = require("../components");
var useInterfaceOptions_1 = __importDefault(require("./useInterfaceOptions"));
var Interface = (0, react_1.forwardRef)(function (_a, ref) {
    var profile = _a.profile;
    var shell = (0, services_1.useServices)().shell;
    var _b = (0, useInterfaceOptions_1.default)(profile), interfaceLanguageSelect = _b.interfaceLanguageSelect, quitOnCloseToggle = _b.quitOnCloseToggle, escExitFullscreenToggle = _b.escExitFullscreenToggle, hideSpoilersToggle = _b.hideSpoilersToggle;
    return (react_1.default.createElement(components_2.Section, { ref: ref, label: 'INTERFACE' },
        react_1.default.createElement(components_2.Option, { label: 'SETTINGS_UI_LANGUAGE' },
            react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, interfaceLanguageSelect))),
        shell.active &&
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_QUIT_ON_CLOSE' },
                react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, quitOnCloseToggle))),
        shell.active &&
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_FULLSCREEN_EXIT' },
                react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, escExitFullscreenToggle))),
        react_1.default.createElement(components_2.Option, { label: 'SETTINGS_BLUR_UNWATCHED_IMAGE' },
            react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, hideSpoilersToggle)))));
});
exports.default = Interface;
